<!--
 * @Descripttion: 单据信息
 * @version: 1
 * @Author: lk
 * @Date: 2019-08-22 10:32:04
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-02 15:34:05
 -->
<template>
  <div>
    <el-form class="orderInfo-form" label-suffix="： ">
      <el-form-item label="单据编号">
        {{ orderInfo.inCode }}
      </el-form-item>
      <el-form-item label="单据类型">
        <dict-tag  :options="dictObj.inType" :value="orderInfo.inType" />
      </el-form-item>
      <el-form-item label="申请部门">
        {{ orderInfo.applyOrgName }}
      </el-form-item>
      <el-form-item label="入库方式">
        <dict-tag  :options="dictObj.warehouseType" :value="orderInfo.inWay" />
      </el-form-item>
      <el-form-item label="生产组织">
        {{ orderInfo.workOrgName }}
      </el-form-item>
      <el-form-item label="生产车间">
        {{ orderInfo.workshop }}
      </el-form-item>
      <el-form-item label="订单编号">
        {{ orderInfo.bizName }}
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getWarehousingOrderInfo } from '@/api/warehousingOrder'

export default {
  props:{
    dictObj:{
      type:Object,
      default:()=>{
        return {
          warehouseType:[]
        }
      }
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      orderInfo: {},
    }
  },
  methods: {
    // 获取单据信息
    open({ id }) {
      // 获取基础信息数据
      this.$emit('changeParentLoading', true)
      getWarehousingOrderInfo(id).then(res => {
        this.orderInfo = res.data
      }).finally(() => {
        this.$emit('changeParentLoading', false)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.orderInfo-form {
  padding-left: 24px;
}

.orderInfo-form ::v-deep .el-form-item {
  margin-bottom: 0px !important;
}
</style>
